import tippy from 'tippy.js';
import 'tippy.js/themes/light-border.css';

$(function(){
	if ($('.tippy-aproval').length > 0){
		tippy('.tippy-aproval', {
				arrow: true,
				animation: 'fade',
				content: '<p class="tippy-text">利用申請が完了後にご利用いただけます。</p>',
				// theme: 'tippy',
				theme: 'light-border',
		});
	}
	if ($('.tippy-jobseeker-quote').length > 0){
		tippy('.tippy-jobseeker-quote', {
				arrow: true,
				animation: 'fade',
				content: '<p class="tippy-text"><strong>内定が決定した求人</strong>にのみ内定報告を行います。</p>',
				// theme: 'tippy',
				theme: 'light-border',
		});
	}
	if ($('.tippy-jobseeker-reports').length > 0){
		tippy('.tippy-jobseeker-reports', {
				arrow: true,
				animation: 'fade',
				content: '<p class="tippy-text">内定報告が完了した求人のみ、業者への評価が可能となります。</p>',
				// theme: 'tippy',
				theme: 'light-border',
		});
	}
});
